import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { 
    FacetV2 as Facet, 
    RangeFacetV2 as RangeFacet,
    RangeFacetCustomV2 as RangeFacetCustom,
    FacetColorV2 as FacetColor,
    SelectedFiltersCustomV2 as SelectedFiltersCustom
} from "../"
import { useCustomConfig } from "../../hooks/useCustomConfig"
import { useFiltersPanelState } from '../../contexts/FiltersPanelStateContext'
import { IconClose } from '../icons/'


const FiltersHead = () => {

    const { customConfig } = useCustomConfig()
    const { openFilters } = useFiltersPanelState()

    return (
        <div className={`head hide medium-down--show scheme color-${customConfig.filters.headColorScheme}`}>
            <div className="title heading-font">Filters</div>
            <button 
                className="close close-filters" 
                ariaLabel="Close Filters Modal"
                onClick={(event) => {
                    event.preventDefault()
                    openFilters(false)
                }}>
                <IconClose />
            </button>
        </div>
    )
}

export default function SideBar({ totalProducts }) {

    const { customConfig } = useCustomConfig()
    const { loading, facets } = useFacets()
    const { isFiltersOpen } = useFiltersPanelState()

    return facets?.length > 0 ? (
        <>
            
            <div
                className={`collection-filters layout-sidebar medium-down--slide-in-modal ${isFiltersOpen && 'open'}`}
            >
                <FiltersHead />
                <div className={`filters-inner ${customConfig.filters.colorScheme}`}>
                
                    <SelectedFiltersCustom totalProducts={totalProducts} />
                    
                    <div className="filters-content">
                        {facets?.map(facet => {                            
                            switch (facet.type) {
                                case "terms":
                                    if (facet.name == 'Color') {
                                        return <FacetColor facet={facet} />
                                    } else {
                                        return <Facet facetIn={facet} />
                                    }
                                case "stats":
                                    if (facet.name == 'Price') {
                                        return <RangeFacetCustom facet={facet} />
                                    } else {
                                        return <RangeFacet facet={facet} />
                                    } 
                                default:
                                    return null
                            }
                        })}
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
